export default __webpack_public_path__ + "static/media/abolanle1.5f6a49a3.webp";